import { CenterAddressType } from "@nkr/enums/index";
import { ICenterAddress, ICenterAddressContract } from "@nkr/models/center-address";
import { AuthActionCreators, IGet } from "@nkr/store/authorization";
import { IAddUpdateCenterAddressResponse, ICenterAddressListResponse } from "@nkr/store/center";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

interface Results {
    loading: boolean,
    error: string,
    address: ICenterAddress,
    fetchData: (centerId: number, addressType: CenterAddressType) => void,
    update: (address: ICenterAddressContract) => void
}

function useCenterAddress(centerId: number, addressType: CenterAddressType): Results {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [address, setAddress] = useState<ICenterAddress>(null);

    const { dispatch } = useAppHookContext();

    useEffect(() => {
        setLoading(true);
        setError('');

        fetchData(centerId, addressType);
    }, [centerId, addressType]);

    const fetchData = async (centerId: number, addressType: CenterAddressType) => {
        let config: IGet = {
            url: `${__API__}/center/${centerId}/addresses?addressType=${addressType}`
        };

        try {
            const response: ICenterAddressListResponse = await dispatch(AuthActionCreators.apiGet(config));

            if (response && response.data.results && response.data.results.length > 0) {
                setAddress(response.data.results[0]);
            } else {
                setAddress(null);
            }

        } catch (err) {
            setError(err);
            setAddress(null);
        } finally {
            setLoading(false);
        }
    };

    const update = async (address: ICenterAddressContract) => {
        setLoading(true);
        setError('');

        let options = {
            url: `${__API__}/center/address`,
            data: address
        };

        try {
            const r: IAddUpdateCenterAddressResponse = await dispatch(address.id ? AuthActionCreators.apiPut(options) : AuthActionCreators.apiPost(options));

            if (r.data.success) {
                setAddress(r.data.results);
            } else {
                setAddress(null);
                setError('An error occured while updating address.');
            }

        } catch (err) {
            setAddress(null);
            setError(err);

        } finally {
            setLoading(false);
        }
    }

    return { loading, error, address, fetchData, update };
}

export default useCenterAddress;